module.exports = __webpack_public_path__ + "img/mijn-leerlijn.f8e893d1.png";